export const FIELD_MAX_LENGTH = {
    NAME: 128,
    LABEL: 50,
    DELTA_COLLECTION: 50,
    DESCRIPTION: 2000,
    TYPE_NVARCHAR: 4000,
    TYPE_VARCHAR: 8000,
    OWNER: 200,
    WHO_TO_SOLVE: 200,
}